import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { adaptApiError, DISABLE_ERROR_INTERCEPTOR } from '@hglobal/fin-ui';
import { Observable } from 'rxjs';

import { environment } from '@iw/environment';

import { AuthApi } from './auth-api.interface';
import { Enable2FAData } from '../models';

@Injectable()
export class AuthApiService implements AuthApi {
  readonly #http = inject(HttpClient);
  readonly #sessionApi = environment.authApiUrl;

  logout(): Observable<void> {
    return this.#http
      .post<void>(this.#sessionApi + `logout`, {})
      .pipe(adaptApiError());
  }

  enable2fa() {
    return this.#http
      .post<Enable2FAData>(this.#sessionApi + `enable-mfa`, {})
      .pipe(adaptApiError());
  }

  verifyCode(code: string) {
    return this.#http
      .post<void>(
        this.#sessionApi + `verify-mfa`,
        { code },
        { context: new HttpContext().set(DISABLE_ERROR_INTERCEPTOR, true) },
      )
      .pipe(adaptApiError());
  }

  resetCode(recoveryCode: string) {
    return this.#http
      .post<void>(
        this.#sessionApi + `reset-mfa`,
        { recoveryCode },
        { context: new HttpContext().set(DISABLE_ERROR_INTERCEPTOR, true) },
      )
      .pipe(adaptApiError());
  }

  remove2fa() {
    return this.#http.delete<void>(this.#sessionApi + `remove`);
  }
}
